import { create } from 'zustand';

const state = { variant: null };

export const useLoader = create((set) => ({
  ...state,
  onShowLoader: (newState) => set((state) => ({ ...state, ...newState })),
  onResetLoader: () => set(() => ({ ...state })),
}));
